export default __webpack_public_path__ + "static/media/mahin-arafath-demo.a40a2184.png";